import { TReduxActions } from '../../actions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lastActionReducer(_: any, action: TReduxActions): TReduxActions {
  return action;
}
